<template>
  <div class="dashboard">
    <section class="hero has-background-dark">
      <div class="hero-body">
        <div class="container">
          <h1 class="title has-text-white">
            Dashboard
          </h1>
          <h2 v-if="user.name" class="subtitle has-text-white">
            Hi {{user.name}}
          </h2>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="tile is-ancestor">
        <div class="tile is-7 is-parent">
          <article class="tile is-child box">
            <tile-battery-chart />
          </article>
        </div>
        <div class="tile is-vertical is-5 is-parent">
          <article class="tile is-child box has-background-primary">
            <tile-linked-trackers :white="true" />
          </article>
          <article class="tile is-child box has-background-dark">

          </article>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tileLinkedTrackers from '@/components/tileLinkedTrackers.vue'
import tileBatteryChart from '@/components/tileBatteryChart.vue'

export default {
  name: 'dashboard',
  components: {
    'tile-linked-trackers': tileLinkedTrackers,
    'tile-battery-chart': tileBatteryChart
  },
  data: () => {
    return {
      error: null
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  async created () {
    if (!await this.$store.dispatch('checkAuthToken')) return this.$router.push('/login')
    this.error = await this.$store.dispatch('getUser')
  }
}
</script>

<style scoped>
.hero {
  margin-bottom: 1em;
}
.tile.is-child {
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}
</style>
